import hres6oeLabels from 'assets/labels/hres6oe'
// import faker from 'faker'
import moment from 'moment'
import _ from 'lodash'
// import assetsLabels from 'assets/js/labels'

export const mocker = {
  labels () {
    return {
      labels: hres6oeLabels
    }
  },
  dropdowns () {
    const codjob = {
      'GMM': 'GMM/P001/17',
      'HAF': 'HAF/P001/17',
      'DKSH': 'DKSH/P001/17',
      'OGP': 'OGP/P001/17',
      'ABC': 'ABC/P001/17',
      'PAN': 'PAN/P001/17'
    }
    const codreason = {
      '0001': 'On Site Service',
      '0002': 'Emergency Call',
      '0003': 'Install Procution',
      'RE01': 'Reason 1',
      'RE02': 'Reason 2',
      'RE03': 'Reason 3',
      '9999': 'อื่นๆ'
    }

    return {
      th: {
        codjob: codjob,
        codreason: codreason
      },
      en: {
        codjob: codjob,
        codreason: codreason
      }
    }
  },
  cust () {
    let mockWorkPlace = [
      {
        codcust: 'AAA',
        namcust: 'AAA',
        title: 'Khon Kean',
        radius: 1000,
        position: {
          lat: 16.418548,
          lng: 102.840058
        },
        address: 'อำเภอเมืองขอนแก่น 40000',
        zipcode: '10110'
      },
      {
        codcust: 'BBB',
        namcust: 'BBB',
        title: 'Indra Square',
        radius: 1000,
        position: {
          lat: 13.753444,
          lng: 100.540403
        },
        address: 'เขต ราชเทวี กรุงเทพมหานคร 10400',
        zipcode: '10110'
      },
      {
        codcust: 'CCC',
        namcust: 'CCC',
        title: 'Route 66',
        radius: 1000,
        position: {
          lat: 13.751556,
          lng: 100.575287
        },
        address: 'จังหวัด กรุงเทพมหานคร 10310',
        zipcode: '10110'
      },
      {
        codcust: 'DDD',
        namcust: 'DDD',
        title: 'Seenspace Bar',
        radius: 1000,
        position: {
          lat: 13.733631,
          lng: 100.581455
        },
        address: '251/1 ซอย ทองหล่อ 13 แขวง คลองตันเหนือ',
        zipcode: '10110'
      },
      {
        codcust: 'EEE',
        namcust: 'EEE',
        title: 'Terminal 21',
        radius: 3000,
        position: {
          lat: 13.737338,
          lng: 100.560598
        },
        address: '88 ซอย สุขุมวิท 19 แขวง คลองเตยเหนือ',
        zipcode: '10110'
      },
      {
        codcust: 'FFF',
        namcust: 'FFF',
        title: 'Central World',
        radius: 300,
        position: {
          lat: 13.746228,
          lng: 100.539819
        },
        address: '4,4/1-4/2 4/4 ถนน ราชดำริ แขวง ปทุมวัน',
        zipcode: '10110'
      },
      {
        codcust: 'GGG',
        namcust: 'GGG',
        title: 'บริษัท พรีมัส (ประเทศไทย) จำกัด',
        radius: 400,
        position: {
          lat: 13.781579,
          lng: 100.579492
        },
        address: '90 อาคารไซเบอร์ เวิลด์, รัชดาภิเษก, แขวงห้วยขวาง',
        zipcode: '10110'
      },
      {
        codcust: 'HHH',
        namcust: 'HHH',
        title: 'บริษัท อาร์คอน เอ็นจิเนียริ่ง จำกัด',
        radius: 100,
        position: {
          lat: 13.778754,
          lng: 100.575769
        },
        address: 'ถนน ประชาราษฎร์บำเพ็ญ แขวง สามเสนนอก',
        zipcode: '10110'
      },
      {
        codcust: 'III',
        namcust: 'III',
        title: 'โตโยต้าเค.มอเตอร์ส',
        radius: 200,
        position: {
          lat: 13.778681,
          lng: 100.575493
        },
        address: '223/8 ถนน ประชาราษฎร์บำเพ็ญ ห้วยขวาง',
        zipcode: '10110'
      },
      {
        codcust: 'JJJ',
        namcust: 'JJJ',
        title: 'บริษัท เคนไซ เซรามิค อินดัสทรี จำกัด',
        radius: 200,
        position: {
          lat: 13.779715,
          lng: 100.573335
        },
        address: '169/94-97 ถ.รัชดาภิเษก แขวงดินแดง เขตดินแดง 10400',
        zipcode: '10110'
      },
      {
        codcust: 'KKK',
        namcust: 'KKK',
        title: 'สุวรรณคชสาร อินเตอร์เนชั่นแนล',
        radius: 200,
        position: {
          lat: 13.775628,
          lng: 100.573693
        },
        address: '200, อาคารทศพล ชั้น 5, ถนนรัชดาภิเษก, แขวงห้วยขวาง ',
        zipcode: '10110'
      },
      {
        codcust: 'LLL',
        namcust: 'LLL',
        title: 'AIIZ',
        radius: 100,
        position: {
          lat: 13.775765,
          lng: 100.571713
        },
        address: '125 ถนนรัชดาภิเษก แขวง ดินแดง',
        zipcode: '10110'
      },
      {
        codcust: 'MMM',
        namcust: 'MMM',
        title: 'JAM COFFEE CORNER',
        radius: 200,
        position: {
          lat: 13.775856,
          lng: 100.572730
        },
        address: '99/2 ซอย เนียมอุทิศ ถนนรัชดาภิเษก แขวง ดินแดง',
        zipcode: '10110'
      },
      {
        codcust: 'NNN',
        namcust: 'NNN',
        title: 'Ray Garden',
        radius: 200,
        position: {
          lat: 13.774578,
          lng: 100.571965
        },
        address: '197 ซอย นาทอง แยก 9 (รัชดาภิเษก 7 แยก 2) ถนน รัชดาภิเษก แขวง ดินแดง',
        zipcode: '10110'
      }
    ]
    return mockWorkPlace
  },
  history () {
    let date
    let mockDetailsTotal
    let mockHres6oe = []
    let mockDay = []
    let mockMonth = []
    let mockRemark = [
      'Additionally, once the system implementation is complete, we provide 6 months warranty service to assist customers on software usage and to ensure that the system can perform at its full potential',
      'UAT ลูกค้าเป็นเวลา 1 เดือน',
      'UAT ลูกค้าเป็นเวลา 1 เดือน'
    ]
    let mockReason = ['001', '002']
    let mockWorkPlaceIndex
    let mockWorkplace = [{
      codcust: 'PAN',
      namcust: 'Pandora Co., Ltd.'
    }, {
      codcust: 'ABC',
      namcust: 'ABC Sofware Co., Ltd.'
    }, {
      codcust: 'OGP',
      namcust: 'Ocean Glass Public Co., Ltd.'
    }, {
      codcust: 'DKSH',
      namcust: 'DKSH Thailand Co., Ltd.'
    }, {
      codcust: 'HAF',
      namcust: 'Hafaele Co., Ltd.'
    }, {
      codcust: 'GMM',
      namcust: 'GMM Grammy Co., Ltd.'
    }]
    for (let i = 2017; i >= 2016; i--) {
      for (let j = 11; j >= 10; j--) {
        mockDay = []
        for (let k = 8; k >= 5; k--) {
          date = _.padStart(k, 2, '0') + '/' + _.padStart(j, 2, '0') + '/' + i
          mockHres6oe = []
          mockDetailsTotal = Math.floor(Math.random() * 3) + 1
          for (let l = 1; l <= mockDetailsTotal; l++) {
            mockWorkPlaceIndex = Math.floor(Math.random() * 6)
            mockHres6oe.push({
              codjob: 'GMM/P001/17',
              codreason: mockReason[l - 1],
              activity: mockRemark[l - 1],
              codcust: mockWorkplace[mockWorkPlaceIndex]['codcust'],
              namcust: mockWorkplace[mockWorkPlaceIndex]['namcust'],
              dtein: date,
              timin: '08.00',
              dteout: '',
              timout: ''
            })
          }
          mockDay.push({
            day: moment(date, 'DD/MM/YYYY').format('D'),
            dayweek: moment(date, 'DD/MM/YYYY').format('ddd'),
            details: mockHres6oe
          })
        }
        mockMonth.push({
          month: _.padStart(j, 2, '0'),
          year: i,
          days: mockDay
        })
      }
    }
    return mockMonth
  },
  lastCheckIn () {
    return {
      'coderror': ' ',
      'desc_coderror': ' ',
      'item_error': ' ',
      'flg': ' ',
      'total': '1',
      'flgcanedit': '1',
      'rcnt': 'Y',
      'dtework': '07/12/2017',
      'seqno': '1',
      'dtein': '19/04/2017',
      'timin': '1134',
      'dteout': '19/04/2017',
      'timout': '1134',
      'codcust': '999',
      'typplace': '1',
      'namcust': 'ไม่ระบุ',
      'codjob': 'UNDEFINED',
      'codreason': '0001',
      'namreason': 'On Site Service',
      'activity': 'test',
      'new_namcust': 'test',
      'phone': '00',
      'filenamei': '',
      'filenameo': ''
    }
  },
  saveCheckIn () {
    return {
      'flg': ' ',
      'coderror': '201',
      'desc_coderror': 'HR2401 ข้อมูลได้รับการบันทึกแล้ว',
      'response': 'HR2401 ข้อมูลได้รับการบันทึกแล้ว'
    }
  },
  saveCheckInDetail () {
    return {
      'flg': ' ',
      'coderror': '201',
      'desc_coderror': 'HR2401 ข้อมูลได้รับการบันทึกแล้ว',
      'response': 'HR2401 ข้อมูลได้รับการบันทึกแล้ว'
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6oe/mocker.js